import { useState, useRef } from "react";
import axios from "axios";

const useApi = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const abortControllerRef = useRef(null);

  const request = async ({
    url,
    method = "GET",
    data = null,
    config = {},
    timeout = 10000,
  }) => {
    setLoading(true);
    setError(null);

    // Abort previous request if still pending
    // if (abortControllerRef.current) {
    //   abortControllerRef.current.abort();
    // }

    abortControllerRef.current = new AbortController();

    try {
      const response = await axios({
        url,
        method,
        data,
        signal: abortControllerRef.current.signal,
        timeout,
        ...config,
      });
      return response.data;
    } catch (err) {
      if (axios.isCancel(err) || err.name === "CanceledError") {
        console.warn("Request was cancelled");
      } else if (err.code === "ECONNABORTED") {
        console.error("Request timeout");
      } else {
        console.error(`${method} request error:`, err);
      }
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   // Cleanup function to abort the request if the component unmounts
  //   return () => {
  //     if (abortControllerRef.current) {
  //       abortControllerRef.current.abort();
  //     }
  //   };
  // }, []);

  return {
    request,
    loading,
    error,
    // cancel: () => abortControllerRef.current?.abort(),
  };
};

export default useApi;
